import React, { useState, useEffect } from "react";
import "./TaskDashboard.css";
import { format, parse } from "date-fns";
import DatePicker from "react-datepicker";
import Navbar from "../../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { empList } from "../../../Redux/DailyUpdateApproval/Action";
import {
  gettaskstatus,
  getProjectMaster,
  getTaskDashbordDataEmployeeWise,
  getTaskDetails,
  getCommentData,
  getWorklogData,
  getcreateTask,
  gettasktype,
  gettaskpriority,
  addTaskComment,
  addTaskWorklog,
} from "../../../Redux/Task/Action";
import { BiSolidMessageRoundedDetail } from "react-icons/bi";
import Swal from "sweetalert2";
import NewGlobalDataTable from "../../DataTable/NewGlobalDataTable";
import Icon from "../../utility/Icon";

const TaskDashboard = () => {
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const { emplists } = useSelector((store) => store.dailyUpdateApprover);
  const [selectedEmployee, setSelectedEmployee] = useState("0");
  const [selectedStatus, setSelectedStatus] = useState("");

  const [selectedprojectCode, setSelectedprojectCode] = useState("");

  const [onEditing, setonEditing] = useState(false);
  const [taskId, setTaskId] = useState("");
  const [show, setShow] = useState(false);
  const [showCommentModal, setshowCommentModal] = useState(false);
  const [showWorklogModal, setshowWorklogModal] = useState(false);
  const handleCloseCommentModal = () => setshowCommentModal(false);
  const handleCloseWorkLog = () => setshowWorklogModal(false);
  const handleClose = () => setShow(false);
  const [status, setStatus] = useState("");
  const [projectCode, setprojectCode] = useState("");
  const [assignId, setassignId] = useState("0");
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
    const [taskNumber, setTaskNumber] = useState("");

  const {
    taskEdit,
    getprojectDropdownData,
    taskType,
    taskPriority,
    taskStatus,
    taskDashboardData,
    taskWorklogdata,
    taskCommentData,
  } = useSelector((store) => store.task);

  const [comment, setComment] = useState({
    comments: "",
  });
  const [workLog, setworkLog] = useState({
    date: "",
    totalHour: "",
  });
  const [task, setTask] = useState({
    projectCode: "",
    module: "",
    title: "",
    type: "",
    startDate: "",
    endDate: "",
    effortReq: 0,
    effortActual: 0,
    priorityCode: "",
    assignId: "",
    status: "",
    taskDesc: "",
    remark: "",
    actionType: "INSERT",
    initiatorId: loginId,
    hrmsTaskMasterId: "",
  });

  useEffect(() => {
    if (taskEdit) {
      setTask((prevData) => ({
        ...prevData,
        projectCode: taskEdit.projectCode,
        module: taskEdit.module,
        title: taskEdit.title,
        type: taskEdit.type,
        startDate: taskEdit.startDate,
        endDate: taskEdit.endDate,
        effortReq: taskEdit.effortReq,
        effortActual: taskEdit.effortActual,
        priorityCode: taskEdit.priorityCode,
        assignId: taskEdit.ownerShipId,
        status: taskEdit.status,
        taskDesc: taskEdit.taskDesc,
        hrmsTaskMasterId: taskEdit.hrmsTaskMasterId,
        actionType: "UPDATE",
      }));
    }
  }, [taskEdit]);

  const handleTaskInputChange = (e) => {
    const { name, value } = e.target;
    //prevent White Spaace
    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }
    // if (name === "effortReq" || name === "effortActual") {
    //   if (/^(0|[1-9]\d*)?$/.test(value)) {
    //     setTask({ ...task, [name]: value });
    //   }
    // }
    if (name === "effortReq" || name === "effortActual") {
      const numericValue = value === "" ? 0 : value;
      if (/^(0|[1-9]\d*)?$/.test(numericValue)) {
        setTask({ ...task, [name]: numericValue });
      }
    } else if (name === "endDate" && task.startDate) {
      const startDate = new Date(task.startDate);
      const endDate = new Date(value);

      if (endDate < startDate) {
        alert("End Date must be after Start Date.");
        return; // Prevent setting the invalid end date
      }
      setTask({ ...task, [name]: value });
    }

    // else if (name === "module" || name === "title" || name === "taskDesc") {
    //   if (/^[a-zA-Z\s]*$/.test(value)) {
    //     setTask({ ...task, [name]: value });
    //   }
    // }
    else {
      setTask({ ...task, [name]: value });
    }
  };

  const handleDateChangeForTaskIput = (date, name) => {
    if (name === "endDate" && task.startDate) {
      const startDate = new Date(task.startDate);

      if (date < startDate) {
        alert("End Date must be after Start Date.");
        return;
      }
    }
    setTask({ ...task, [name]: date });
  };

  const handleCommentChange = (e) => {
    const { name, value } = e.target;
    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }
    if (/^[a-zA-Z\s]*$/.test(value)) {
      setComment({ ...comment, [name]: value });
    }
  };

  const handleWorklogInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "totalHour") {
      if (/^(0|[1-9]\d*)?$/.test(value)) {
        let newValue = value;

        if (parseInt(newValue) > 24) {
          newValue = 24;
          alert("Hours should be less then 24.");
          setworkLog("");
          return;
        }

        setworkLog({ ...workLog, [name]: value });
      }
    } else {
      setworkLog({ ...workLog, [name]: value });
    }
  };

  useEffect(() => {
    dispatch(empList(token));
    dispatch(gettasktype(token));
    dispatch(gettaskpriority(token));
    dispatch(gettaskstatus(token));
    dispatch(getProjectMaster(token));
  }, [dispatch, token]);

  emplists.map((emp) => ({
    value: emp.loginId,
    label: `${emp.firstName} ${emp.lastName}`,
    empId: emp.loginId,
  }));

  useEffect(() => {
    if (assignId && assignId === "0" && !projectCode && !status) {
      dispatch(
        getTaskDashbordDataEmployeeWise(assignId, status, projectCode, token, pageNumber - 1, pageSize)
      );
    } else if (assignId) {
      dispatch(
        getTaskDashbordDataEmployeeWise(assignId, status, projectCode, token, pageNumber - 1, pageSize)
      );
    } else {
      dispatch(
        getTaskDashbordDataEmployeeWise(loginId, status, projectCode, token, pageNumber - 1, pageSize)
      );
    }
  }, [dispatch, loginId, assignId, status, projectCode, token, pageNumber, pageSize]);

  const handleStatusChange = (e) => {
    const selectedValue = e.target.value;
    setStatus(e.target.value);
    setSelectedStatus(selectedValue);
  };

  const handleprojectCodeChange = (e) => {
    const selectedValue = e.target.value;
    setprojectCode(e.target.value);
    setSelectedprojectCode(selectedValue);
  };

  const handleEmpChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedEmployee(selectedValue);
    setassignId(e.target.value);
  };

  const handelfetchTaskDetails = (e) => {
    dispatch(getTaskDetails(e.hrmsTaskMasterId, token));
    setonEditing(true);
    setShow(true);
  };

  const handelfetchComment = (e) => {
    dispatch(getTaskDetails(e.hrmsTaskMasterId, token));
    setTaskId(e.hrmsTaskMasterId);
    setshowCommentModal(true);
    setTaskNumber(e.taskNo);
    dispatch(getCommentData(e.hrmsTaskMasterId, token));
  };

  const handelfetchWorklog = (e) => {
    dispatch(getWorklogData(e.hrmsTaskMasterId, token));
    setTaskId(e.hrmsTaskMasterId);
    setshowWorklogModal(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!task.startDate || !task.endDate) {
      alert("Both Start And End Date Is Required");
      return;
    }
    const taskData = {
      ...task,
      effortActual: task.effortActual || 0,
      effortReq: task.effortReq || 0,
    };
    Swal.fire({
      title: "Are you sure?",
      html: `Do you want to submit the task details?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // dispatch(getcreateTask(task, token))
        dispatch(getcreateTask(taskData, token))
          .then(({ success }) => {
            if (success) {
              handleClose();
              dispatch(
                getTaskDashbordDataEmployeeWise(
                  loginId,
                  status,
                  projectCode,
                  token,
                  pageNumber - 1,
                  pageSize
                )
              );
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Task details submitted successfully.",
                timer: 4000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "There was an error submitting the task details.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error in catch submitting the task details.",
              icon: "error",
              timer: 5000,
              confirmButtonText: "OK",
            });
          });
      }
    });
  };
  const handleSubmitComment = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      html: `Do you want to submit the Comment ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const commentdata = {
          taskMasterId: taskId,
          loginId: loginId,
          commentsId: "",
          name: "",
          action: "",
          createdDate: "",
          comments: comment.comments,
        };
        dispatch(addTaskComment(commentdata, token))
          .then(({ success }) => {
            if (success) {
              handleCloseCommentModal(false);
              setComment(true);
              dispatch(getCommentData(taskId, token));
              setshowCommentModal(true);
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Comment Added successfully.",
                timer: 4000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "There was an error submitting the Comment.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error in  submitting the Comment.",
              icon: "error",
              timer: 5000,
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const handelSubmitWorklog = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      html: `Do you want to submit the WorkLog ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const workLogDatas = {
          taskMasterId: taskId,
          userId: loginId,
          date: workLog.date,
          totalHour: workLog.totalHour,
        };
        dispatch(addTaskWorklog(workLogDatas, token))
          .then(({ success }) => {
            if (success) {
              handleCloseWorkLog(false);
              setworkLog(true);
              dispatch(getWorklogData(taskId, token));
              setshowWorklogModal(true);
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "WorkLog submitted successfully.",
                timer: 4000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "There was an error submitting the WorkLog.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error in catch submitting the WorkLog.",
              icon: "error",
              timer: 5000,
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  const columns = [
    {
      name: "Task No",
      selector: (row) => row.taskNo,
      sortable: true,
    },
    {
      name: "Project",
      selector: (row) => row.projectCode,
      sortable: true,
    },
    {
      name: "Date Range",
      selector: (row) => (
        <div>
          {row.startDate} <br />
          {row.endDate}
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Ownership",
      selector: (row) => row.ownershipName,
      sortable: true,
    },
    {
      name: "Assign To",
      selector: (row) => row.assignName || '-',
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Task Title",
      selector: (row) => row.title,
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => row,
      sortable: true,
      cell: (row) => (
        <div>
          <Tooltip text="View Comments">
            <Icon
              icon={BiSolidMessageRoundedDetail}
              variant="success"
              onClick={() => handelfetchComment(row)}
            />
          </Tooltip>

        </div>
      ),
    },
  ];
  const conditionalRowStyles = [
    {
      when: (row) => row.status === "To Do",
      style: {
        backgroundColor: "#7F8C8D", //Slate Gray
        color: "white",
      },
    },
    {
      when: (row) => row.status === "In Progress",
      style: {
        backgroundColor: "#8e44ad", //Royal Purple
        color: "white",
      },
    },
    {
      when: (row) => row.status === "In Testing",
      style: {
        backgroundColor: "#34495e", //Charcoal Gray
        color: "white",
      },
    },
    {
      when: (row) => row.status === "Rejected",
      style: {
        backgroundColor: "#e74c3c", //Crimson Red
        color: "white",
      },
    },
    {
      when: (row) => row.status === "Reopened",
      style: {
        backgroundColor: "#2ecc71", //Emerald Green
        color: "white",
      },
    },
    {
      when: (row) => row.status === "Done",
      style: {
        backgroundColor: "#05e35a",
        color: "white",
      },
    },
  ];

  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div className="row mb-3 justify-content align-items-center">
            <div className="col-sm-4 d-flex align-items-center">
              <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <b>
                  <label className="custom-label">Employee :-</label>
                </b>
              </div>
              <br />
              <select
                name="assignId"
                value={selectedEmployee || ""}
                onChange={handleEmpChange}
                id="assignId"
                className="form-select"
              >
                <option value="0">ALL</option>
                {emplists.map((emp, index) => (
                  <option key={index} value={emp.loginId}>
                    {emp.firstName} {emp.lastName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-4 d-flex align-items-center">
              <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <b>
                  <label className="custom-label" id="">
                    Status :-
                  </label>
                </b>
              </div>
              <br />
              <select
                name="status"
                value={selectedStatus || ""}
                onChange={handleStatusChange}
                id="status"
                className="form-select"
              >
                <option value="A">All</option>
                {taskStatus &&
                  taskStatus.map((stat) => (
                    <option key={stat.ticketStatusId} value={stat.status}>
                      {stat.description}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-sm-4 d-flex align-items-center">
              <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <b>
                  <label className="custom-label">Project :-</label>
                </b>
              </div>
              <br />
              <select
                name="projectCode"
                value={selectedprojectCode || ""}
                onChange={handleprojectCodeChange}
                id="projectCode"
                className="form-select"
              >
                <option value="A">All</option>
                {getprojectDropdownData.map((projectCode) => (
                  <option
                    key={projectCode.projectMasterId}
                    value={projectCode.projectCode}
                  >
                    {projectCode.projectName}
                  </option>
                ))}
              </select>
            </div>
          </div>



          <NewGlobalDataTable
            columns={columns}
            data={taskDashboardData.taskMaster}
            tableName={'TASK DASHBOARD'}
            setPageSize={setPageSize}
            setPageNumber={setPageNumber}
            totalRecord={taskDashboardData.totalRecord}
          />


          {/* this is comment Modal */}
          {showCommentModal && <div className="modal-backdrop fade show"></div>}
          <div
            className={`modal fade comment-modal ${showCommentModal ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Comment Details for Task No : {taskNumber || ""}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseCommentModal}
                  ></button>
                </div>
                <div className="modal-body comment-modal-body">
                  <h5 className="section-title">Project Details</h5>

                  {/* Project Info Section */}
                  <div className="row g-3 project-details">
                    <div className="col-md-4 col-12">
                      <label>Project</label>
                      <div className="info-box">{taskEdit.projectCode}</div>
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Module</label>
                      <div className="info-box">{taskEdit.module}</div>
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Task Title</label>
                      <div className="info-box">{taskEdit.title}</div>
                    </div>
                    <div className="col-12">
                      <label>Description</label>
                      <div className="info-box">{taskEdit.taskDesc}</div>
                    </div>
                  </div>

                  {/* Comment Input Section */}
                  <h5 className="section-title mt-4">Add Comment</h5>
                  <form onSubmit={handleSubmitComment}>
                    <textarea
                      className="form-control comment-textarea"
                      name="comments"
                      value={comment.comments || ""}
                      onChange={handleCommentChange}
                      id="comments"
                      placeholder="Write your comment here..."
                      required
                    ></textarea>
                    <button type="submit" className="btn btn-success mt-3">
                      Add Comment
                    </button>
                  </form>

                  {/* Comment History Section */}
                  <h5 className="section-title mt-4">Previous Comments</h5>
                  <div className="comment-list">
                    {taskCommentData && taskCommentData.length > 0 ? (
                      taskCommentData.map((c, index) => {
                        const parsedDate = parse(c.createdDate, "EEE MMM dd HH:mm:ss 'IST' yyyy", new Date());
                        const formattedDate = format(parsedDate, "dd MMM yyyy h:mm a");
                        return (
                          <div key={index} className="comment-card">
                            <div className="comment-header">
                              <span className="comment-author">{c.name}</span>
                              <span className="comment-date">{formattedDate}</span>
                            </div>
                            <div className="comment-text">{c.comments}</div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center text-muted mt-3">No comments available</div>
                    )}
                  </div>

                </div>

              </div>
            </div>
          </div>

          {/* this is edit modal  */}
          {show && <div className="modal-backdrop fade show"></div>}

          <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {onEditing ? "Update Task Deatils" : "Add Task Details"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                  ></button>
                </div>
                <div className="modal-body">
                  {/*---------------------------- form inputs--------------- */}
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label htmlFor="projectCode" className="form-label">
                          Project
                        </label>
                        <select
                          name="projectCode"
                          value={task.projectCode || ""}
                          onChange={handleTaskInputChange}
                          id="projectCode"
                          className="form-select"
                          required
                        >
                          <option value="">Choose Option...</option>
                          {getprojectDropdownData.map((projectCode) => (
                            <option
                              key={projectCode.projectMasterId}
                              value={projectCode.projectCode}
                            >
                              {projectCode.projectName}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="module" className="form-label">
                          Module
                        </label>
                        <input
                          type="text"
                          name="module"
                          value={task.module || ""}
                          onChange={handleTaskInputChange}
                          className="form-control"
                          id="module"
                          required
                        />
                      </div>
                    </div>
                    {/*---------------------------- Line 2--------------- */}
                    <div className="row g-3">
                      <div className="col-md-12">
                        <label htmlFor="title" className="form-label">
                          Task Title
                        </label>
                        <input
                          type="text"
                          name="title"
                          value={task.title || ""}
                          onChange={handleTaskInputChange}
                          className="form-control"
                          id="title"
                          placeholder="Enter Task Title.."
                          required
                        />
                      </div>
                    </div>
                    {/*---------------------------- Line 3--------------- */}
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label htmlFor="startDate" className="form-label">
                          Start Date
                        </label>
                        <DatePicker
                          selected={task.startDate || ""}
                          onChange={(newValue) => {
                            handleDateChangeForTaskIput(newValue, "startDate");
                          }}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          onKeyDown={(event) => event.preventDefault()}
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="endDate" className="form-label">
                          End Date
                        </label>
                        <DatePicker
                          selected={task.endDate || ""}
                          onChange={(newValue) => {
                            handleDateChangeForTaskIput(newValue, "endDate");
                          }}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          onKeyDown={(event) => event.preventDefault()}
                          minDate={task.startDate}
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="type" className="form-label">
                          Type
                        </label>
                        <select
                          name="type"
                          value={task.type || ""}
                          onChange={handleTaskInputChange}
                          id="type"
                          className="form-select"
                          required
                        >
                          <option value="">Choose Option...</option>
                          {taskType &&
                            taskType.map((task, index) => (
                              <option key={index} value={task.ticketTypeId}>
                                {task.ticketType}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    {/*---------------------------- Line 4--------------- */}
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label htmlFor="effortReq" className="form-label">
                          Effort Request
                        </label>
                        <input
                          type="number"
                          name="effortReq"
                          value={task.effortReq || ""}
                          onChange={handleTaskInputChange}
                          className="form-control"
                          id="effortReq"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="effortActual" className="form-label">
                          Effort Actual
                        </label>
                        <input
                          type="number"
                          name="effortActual"
                          value={task.effortActual || ""}
                          onChange={handleTaskInputChange}
                          className="form-control"
                          id="effortActual"
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="priorityCode" className="form-label">
                          Priority
                        </label>
                        <select
                          name="priorityCode"
                          value={task.priorityCode || ""}
                          onChange={handleTaskInputChange}
                          id="priorityCode"
                          className="form-select"
                          required
                        >
                          <option value="">Choose Option...</option>
                          {taskPriority &&
                            taskPriority.map((task) => (
                              <option
                                key={task.priorityId}
                                value={task.priorityCode}
                              >
                                {task.priorityName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    {/*---------------------------- Line 5--------------- */}
                    <div className="row g-3">
                      <div className="col-md-8">
                        <label htmlFor="assignId" className="form-label">
                          Ownership To
                        </label>
                        <select
                          name="assignId"
                          value={task.assignId || ""}
                          onChange={handleTaskInputChange}
                          id="assignId"
                          className="form-select"
                          required
                          disabled={onEditing}
                        >
                          <option value="">Choose Option...</option>
                          {emplists.map((emp, index) => (
                            <option key={index} value={emp.loginId}>
                              {emp.firstName} {emp.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select
                          name="status"
                          value={task.status || ""}
                          onChange={handleTaskInputChange}
                          id="status"
                          className="form-select"
                          required
                        >
                          <option value="">Choose Option...</option>
                          {taskStatus &&
                            taskStatus.map((task) => (
                              <option
                                key={task.ticketStatusId}
                                value={task.status}
                              >
                                {task.description}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="row g-3">
                      <div className="form-group mb-3">
                        <label className="form-label" htmlFor="taskDesc">
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          name="taskDesc"
                          value={task.taskDesc || ""}
                          onChange={handleTaskInputChange}
                          id="taskDesc"
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col text-center mt-3">
                        <button type="submit" className="btn btn-primary">
                          {onEditing ? "UPDATE" : "SUBMIT"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* this is worklog modal  */}
          {showWorklogModal && <div className="modal-backdrop fade show"></div>}
          <div
            className={`modal fade ${showWorklogModal ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">WorkLog</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseWorkLog}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handelSubmitWorklog}>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label htmlFor="date" className="form-label">
                          Date
                        </label>
                        <DatePicker
                          selected={workLog.date || ""}
                          onChange={(date) =>
                            setworkLog({
                              ...workLog,
                              date: date ? format(date, "yyyy-MM-dd") : "",
                            })
                          }
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Select Date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          onKeyDown={(event) => event.preventDefault()}
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="totalHour" className="form-label">
                          Hours
                        </label>
                        <input
                          type="number"
                          name="totalHour"
                          value={workLog.totalHour || ""}
                          onChange={handleWorklogInputChange}
                          className="form-control"
                          id="totalHour"
                          max="24"
                          required
                        />
                      </div>
                      <div className="col-md-4 d-flex align-items-end">
                        <button className="btn btn-success" type="submit">
                          Log Work
                        </button>
                      </div>
                    </div>
                  </form>
                  <br />
                  <div className="row g-3">
                    <table className="table mt-3">
                      <thead>
                        <tr>
                          <th>Emp Name</th>
                          <th>Date</th>
                          <th>Total Hour</th>
                        </tr>
                      </thead>
                      <tbody>
                        {taskWorklogdata && taskWorklogdata.length > 0 ? (
                          taskWorklogdata.map((workLog, index) => (
                            <tr key={index}>
                              <td>{workLog.empName}</td>
                              <td>{workLog.date}</td>
                              <td>{workLog.totalHour}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center">
                              No comments available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* containerdiv */}
        </div>
      </div>
    </div>
  );
};

export default TaskDashboard;
